"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailTabs = void 0;
var React = require("react");
var DetailTabs_styles_1 = require("./DetailTabs.styles");
var DetailTabs = /** @class */ (function (_super) {
    __extends(DetailTabs, _super);
    function DetailTabs(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            CurrentIndex: Math.max(Math.min(props.DefaultCurrentIndex, props.Sections.length - 1), 0),
        };
        return _this;
    }
    DetailTabs.prototype.render = function () {
        var _this = this;
        return (React.createElement(DetailTabs_styles_1.Tabs, null,
            React.createElement(DetailTabs_styles_1.UL, { role: "tablist" }, this.props.Sections.map(function (item, index) {
                var handleClick = function () {
                    if (!item.Disabled) {
                        _this.setState({ CurrentIndex: index });
                        _this.props.OnItemClick(item);
                    }
                };
                return (React.createElement(DetailTabs_styles_1.LI, { key: item.Caption, role: "tab", "aria-selected": index === _this.state.CurrentIndex && !item.Disabled, "aria-disabled": item.Disabled },
                    React.createElement(DetailTabs_styles_1.Button, { disabled: item.Disabled, "aria-disabled": item.Disabled, onClick: handleClick }, item.Caption),
                    React.createElement(DetailTabs_styles_1.Bar, null)));
            }))));
    };
    DetailTabs.defaultProps = {
        DefaultCurrentIndex: 0,
    };
    return DetailTabs;
}(React.Component));
exports.DetailTabs = DetailTabs;
